import { Form as FactorialForm } from 'factorial-form'
import moment from 'moment'
import { computed, makeObservable } from 'mobx'

import { MINIMUM_EFFECTIVE_AT_MOMENT } from 'modules/time_planning/lib/constants'
import { stringToDate } from 'modules/core/lib/dates'
import { PLANNING_TOOL } from 'modules/time_planning/store/models/PlanningVersion'

class PlanningVersionForm extends FactorialForm {
  constructor(values: object) {
    super(values, {
      id: 'string',
      effective_at: 'string',
      planning_tool: 'string',
      number_of_rest_days_in_cents: 'number',
      schedule_id: 'string',
      employee_id: 'string'
    })

    makeObservable(this, {
      isValid: computed,
      planningTool: computed,
      numberOfRestDays: computed,
      isContractHoursTool: computed,
      isWorkScheduleTool: computed,
      isShiftManagementTool: computed
    })
  }

  get isValid(): boolean {
    const scheduleValid = !this.isWorkScheduleTool || !!this.get('schedule_id').value
    const effectiveAtValue = this.get('effective_at').value
    let parsedDate = moment.invalid()

    if (effectiveAtValue instanceof Date) {
      parsedDate = moment(effectiveAtValue)
    } else if (typeof effectiveAtValue === 'string') {
      const backendDate = stringToDate(effectiveAtValue, 'backend')
      if (backendDate.isValid()) {
        parsedDate = backendDate
      } else {
        const uiDate = stringToDate(effectiveAtValue, 'ui')
        parsedDate = uiDate.isValid() ? uiDate : moment(effectiveAtValue, 'L')
      }
    }
    const dateValid =
      parsedDate.isValid() && !parsedDate.isBefore(MINIMUM_EFFECTIVE_AT_MOMENT, 'day')

    return scheduleValid && dateValid
  }

  get planningTool(): string {
    return this.get('planning_tool').value
  }

  get numberOfRestDays(): number {
    return this.get('number_of_rest_days_in_cents').value
  }

  get isContractHoursTool(): boolean {
    return this.planningTool === PLANNING_TOOL.contractHours
  }

  get isWorkScheduleTool(): boolean {
    return this.planningTool === PLANNING_TOOL.workSchedule
  }

  get isShiftManagementTool(): boolean {
    return this.planningTool === PLANNING_TOOL.shiftManagement
  }

  cleanNumberOfRestDaysInCents(): void {
    this.setValues({
      number_of_rest_days_in_cents: null
    })
  }
}

export default PlanningVersionForm
